import A1 from "./Images/A1.jpg";
import A2 from "./Images/A2.jpg";
import A3 from "./Images/A3.jpg";
import A4 from "./Images/A4.jpg";
import A5 from "./Images/A5.jpg";
export const photoSizes = [
  {
    name: "A1",
    size: "22'x32'",
    price: 3500,
    img: A1,
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    name: "A2",
    size: "16'x24'",
    price: 1700,
    img: A2,
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    name: "A3",
    size: "12'x18'",
    price: 950,
    img: A3,
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    name: "A4",
    size: "8'x12'",
    price: 550,
    img: A4,
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    name: "A5",
    size: "6'x8'",
    price: 400,
    img: A5,
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
];

export const cartItems = [
  {
    name: "A1",
    size: "22'x32'",
    price: 3500,
    img: A1,
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    name: "A2",
    size: "16'x24'",
    price: 1700,
    img: A2,
    description:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
];
